var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecuoyasOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55.8533,
    rx: 27.5,
    fill: "#EBD7F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 41.6316V27.013M27.5001 33.4086H22.0181C17.9812 33.4086 14.7087 30.1361 14.7087 26.0993V20.6173H20.1907C24.2276 20.6173 27.5001 23.8898 27.5001 27.9266V33.4086ZM27.5001 27.9266H32.9821C37.0189 27.9266 40.2914 24.6541 40.2914 20.6173V15.1353H34.8094C30.7726 15.1353 27.5001 18.4078 27.5001 22.4446V27.9266ZM27.5001 27.9266L34.8094 20.6173M27.5001 33.4086L20.1907 26.0993",
    stroke: "black",
    strokeWidth: 1.82733
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuoyasOn);
export default __webpack_public_path__ + "static/media/secuoyas_on.5049a52a6ff9a028a1c3b2fee4a0ae6c.svg";
export { ForwardRef as ReactComponent };